import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { MarkedCandidates } from '@/features/marked-candidates'

const markedCandidatesSearchSchema = z.object({
  view: z.enum(['job-based', 'priority-list']).optional().catch('job-based'),
  jobId: z.string().optional(),
  tab: z.enum(['alt-jobs', 'p1', 'p2', 'p3']).optional().catch('alt-jobs'),
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(50),
  filter: z.string().optional().catch(''),
})

export const Route = createFileRoute('/_authenticated/marked-candidates/')({
  validateSearch: markedCandidatesSearchSchema,
  component: MarkedCandidates,
})
